import { render, staticRenderFns } from "./TradeAmountRank.vue?vue&type=template&id=0643cd66&scoped=true"
import script from "./TradeAmountRank.vue?vue&type=script&lang=js"
export * from "./TradeAmountRank.vue?vue&type=script&lang=js"
import style0 from "./TradeAmountRank.vue?vue&type=style&index=0&id=0643cd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643cd66",
  null
  
)

export default component.exports